export default __webpack_public_path__ + "static/media/breed.72f77d6b.jpg";